<section class="confirm-message-content">
  <ng-content></ng-content>
</section>
<section class="confirm-message-buttons">
  <ion-button
    color="light"
    size="small"
    (click)="confirmOk.emit()"
    [disabled]="isOkButtonDisabled"
    >{{ okButtonKey || 'general_ok' | translate }}</ion-button
  >
  <ion-button
    color="light"
    size="small"
    fill="outline"
    (click)="confirmCancel.emit()"
    >{{ cancelButtonKey || 'general_cancel' | translate }}</ion-button
  >
</section>
